import { getNavigator } from '@src/helpers/getNavigator';

export const isIPhone = () => {
    const userAgent = getNavigator();

    return userAgent !== undefined && userAgent.toLowerCase().indexOf('iphone') !== -1;
};
